import { render, staticRenderFns } from "./carouselIndex.vue?vue&type=template&id=5bdb8558&scoped=true"
import script from "./carouselIndex.vue?vue&type=script&lang=js"
export * from "./carouselIndex.vue?vue&type=script&lang=js"
import style0 from "./carouselIndex.vue?vue&type=style&index=0&id=5bdb8558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdb8558",
  null
  
)

export default component.exports